import { type NexusApiActionDef } from "./action-def.types";
import { arr, num, obj } from "./output-format.builders";

const WORKFLOW_STATUS_OPTIONS = {
  allowedValues: ["", "DRAFT", "PUBLISHED", "ARCHIVED", "PAUSED"],
  allowedOptions: [
    { label: "All", value: "" },
    { label: "Draft", value: "DRAFT" },
    { label: "Published", value: "PUBLISHED" },
    { label: "Archived", value: "ARCHIVED" },
    { label: "Paused", value: "PAUSED" }
  ]
};

export const workflowActions: NexusApiActionDef[] = [
  {
    action: "workflows.list",
    label: "List Workflows",
    description: "List workflows in the organization",
    inputSchema: {
      status: {
        type: "string",
        description: "Filter by workflow status (optional)",
        constraints: WORKFLOW_STATUS_OPTIONS
      },
      includeArchived: {
        type: "boolean",
        description: "Include archived workflows (optional, default false)"
      },
      limit: { type: "number", description: "Max results (optional, default 50, max 100)" },
      offset: { type: "number", description: "Number of results to skip (optional, default 0)" }
    },
    outputFormat: obj("Result", {
      workflows: arr("List of workflows"),
      total: num("Total matching workflows"),
      limit: num("Page size applied"),
      offset: num("Offset applied")
    })
  },
  {
    action: "workflows.get",
    label: "Get Workflow",
    description: "Get workflow details by ID",
    inputSchema: {
      workflowId: { type: "string", description: "Workflow ID" }
    },
    outputFormat: obj("Workflow details")
  }
];
